<template>
  <div class="tvsi">
    <div class="tvsi__inner">

      <!-- Header -->
      <div class="tvsi__header">
        <h1 class="tvsi__title">{{ $t('about.backcome') }}</h1>
        <p class="tvsi__subtitle">{{ $t('about.policyTVSI') }}</p>
      </div>

      <!-- Tree -->
      <div class="tvsi__tree">

        <!-- L1: Root -->
        <div class="tvsi__level">
          <div class="tvsi__node tvsi__node--primary">
            <div class="tvsi__node-logo">TVSI</div>
            <div>
              <div class="tvsi__node-title">{{ $t('about.backcomeTVSI') }}</div>
              <div class="tvsi__node-sub">{{ $t('about.TVSI_BS') }}</div>
            </div>
          </div>
          <div class="tvsi__conn tvsi__conn--v"></div>
        </div>

        <!-- L2: You -->
        <div class="tvsi__level">
          <div class="tvsi__node tvsi__node--you">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="tvsi__you-icon">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
            </svg>
            <div>
              <div class="tvsi__node-title">{{ $t('common.you') }}</div>
              <div class="tvsi__node-sub">{{ $t('about.policyTVSI') }}</div>
            </div>
          </div>
          <!-- Fork -->
          <div class="tvsi__fork">
            <div class="tvsi__fork-v"></div>
            <div class="tvsi__fork-h"></div>
            <div class="tvsi__fork-leg tvsi__fork-leg--left"></div>
            <div class="tvsi__fork-leg tvsi__fork-leg--right"></div>
          </div>
        </div>

        <!-- L3 + L4 + L5: Branches -->
        <div class="tvsi__branches">

          <!-- Left: Customer -->
          <div class="tvsi__branch">
            <div class="tvsi__node tvsi__node--action">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="tvsi__action-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              <div>
                <div class="tvsi__node-title">{{ $t('about.introduceCustomer') }}</div>
                <div class="tvsi__node-sub">{{ $t('about.customerDevelop') }}</div>
              </div>
            </div>
            <div class="tvsi__conn tvsi__conn--v"></div>
            <div class="tvsi__node tvsi__node--result">
              <div class="tvsi__pct">50%</div>
              <div class="tvsi__result-label">{{ $t('about.yourBackcome') }}</div>
              <div class="tvsi__result-note">{{ $t('about.backcomeToTVSI') }}</div>
            </div>
          </div>

          <!-- Right: Partner -->
          <div class="tvsi__branch">
            <div class="tvsi__node tvsi__node--action">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="tvsi__action-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2V6"/>
              </svg>
              <div>
                <div class="tvsi__node-title">{{ $t('about.introduceParner') }}</div>
                <div class="tvsi__node-sub">{{ $t('about.parnerDevelop') }}</div>
              </div>
            </div>
            <div class="tvsi__conn tvsi__conn--v"></div>
            <div class="tvsi__node tvsi__node--result">
              <div class="tvsi__pct">10%</div>
              <div class="tvsi__result-label">{{ $t('about.totalIncome10') }}</div>
              <div class="tvsi__result-note">{{ $t('about.parnerSuch') }}</div>
            </div>
            <!-- Sub-fork -->
            <div class="tvsi__fork tvsi__fork--sm">
              <div class="tvsi__fork-v"></div>
              <div class="tvsi__fork-h tvsi__fork-h--sm"></div>
              <div class="tvsi__fork-leg tvsi__fork-leg--left"></div>
              <div class="tvsi__fork-leg tvsi__fork-leg--right"></div>
            </div>
            <div class="tvsi__sub-row">
              <div class="tvsi__node tvsi__node--sub">
                <div class="tvsi__pct tvsi__pct--sm">50%</div>
                <div class="tvsi__sub-label">{{ $t('about.backcomeParner') }}</div>
              </div>
              <div class="tvsi__node tvsi__node--sub">
                <div class="tvsi__pct tvsi__pct--sm">10%</div>
                <div class="tvsi__sub-label">{{ $t('about.underParner') }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Notes -->
      <div class="tvsi__notes">
        <div class="tvsi__notes-head">
          <div class="tvsi__notes-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <h3>{{ $t('about.noteImportant') }}</h3>
        </div>
        <div class="tvsi__notes-grid">
          <div v-for="note in importantNotes" :key="note.id" class="tvsi__note-item">
            <span class="tvsi__note-dot" :style="{ background: note.color }"></span>
            <p>{{ note.text }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script src="./tree-tvsi.js"></script>
<style src="./tree-tvsi.scss" lang="scss"></style>
